import api from '@/lib/api';

export interface Signature {
  id: string;
  user_id: string;
  organization_id: string;
  signature_html: string;
  signature_text: string | null;
  is_active: boolean;
  template_id?: string | null;
  created_at: string;
  updated_at: string;
  organization_name?: string;
  organization_domain?: string;
  user_first_name?: string;
  user_last_name?: string;
  user_email?: string;
  template_name?: string | null;
}

export interface CreateSignatureData {
  signatureHtml: string;
  signatureText?: string;
}

export interface UpdateSignatureData {
  signatureHtml?: string;
  signatureText?: string;
}

export interface SignatureResponse {
  success: boolean;
  data: Signature;
  message?: string;
}

export interface SignaturesResponse {
  success: boolean;
  data: Signature[];
}

export interface ToggleSignatureData {
  isActive: boolean;
}

class SignaturesService {
  // Get all signatures for current user
  async getUserSignatures(): Promise<SignaturesResponse> {
    const response = await api.get<SignaturesResponse>('/signatures');
    return response.data;
  }

  // Get signature for specific organization
  async getSignature(organizationId: string): Promise<SignatureResponse> {
    const response = await api.get<SignatureResponse>(`/signatures/${organizationId}`);
    return response.data;
  }

  // Create or update signature for organization
  async upsertSignature(
    organizationId: string,
    data: CreateSignatureData
  ): Promise<SignatureResponse> {
    const response = await api.post<SignatureResponse>(
      `/signatures/${organizationId}`,
      data
    );
    return response.data;
  }

  // Delete signature
  async deleteSignature(organizationId: string): Promise<{ success: boolean; message: string }> {
    const response = await api.delete(`/signatures/${organizationId}`);
    return response.data;
  }

  // Toggle signature active status
  async toggleSignatureStatus(
    organizationId: string,
    isActive: boolean
  ): Promise<SignatureResponse> {
    const response = await api.patch<SignatureResponse>(
      `/signatures/${organizationId}/toggle`,
      { isActive }
    );
    return response.data;
  }
}

export default new SignaturesService();
